import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { apolloClient } from './api/apolloClient';
import App from './app/App';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/WebsocketContext';
import { initTheme } from './helpers/theme';
import store from './store/store';
import './globals.scss';

initTheme();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find root element');

createRoot(rootElement).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <ReduxProvider store={store}>
          <AuthProvider>
            <ToastProvider>
              <SocketProvider>
                <App />
              </SocketProvider>
            </ToastProvider>
          </AuthProvider>
        </ReduxProvider>
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
);
